import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ct-card" }
const _hoisted_2 = { class: "ct-content" }
const _hoisted_3 = { class: "ct-title" }
const _hoisted_4 = {
  key: 0,
  class: "ct-preview"
}
const _hoisted_5 = {
  key: 1,
  class: "ct-meta"
}

import { computed } from "vue";

interface Props {
  subject?: string;
  preview?: string;
  at?: number | string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomToast',
  props: {
    subject: {},
    preview: {},
    at: {}
  },
  setup(__props: any) {

const props = __props;

const formattedTime = computed(() => {
  if (!props.at) return "";
  const d = typeof props.at === "number" ? new Date(props.at) : new Date(props.at);
  return isNaN(d.getTime()) ? "" : d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ct-icon" }, "📬", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.subject || "Nouveau message"), 1),
      (__props.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.preview), 1))
        : _createCommentVNode("", true),
      (__props.at)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(formattedTime.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})